import { ColumnDef } from "@tanstack/react-table";
import { LineClampedTooltip } from "@/core/components/line-clamped-tooltip";
import {
  calcReferralSourceStatus,
  ReferralSourceStatusBadge,
  REFERRAL_SOURCE_STATUSES,
} from "@/business-settings/referral-sources/referral-source-status-badge";
import { formatDate } from "@/core/utils/date";
import { ReferralSource } from "@/referral-sources/referral-source";

type ColType = ColumnDef<ReferralSource>;

export const NameCol = (): ColType => ({
  header: "Name",
  accessorKey: "name",
  sortingFn: "alphanumeric",
  cell: ({ getValue }) => (
    <LineClampedTooltip>{getValue() as string}</LineClampedTooltip>
  ),
});

export const DescriptionCol = (): ColType => ({
  header: "Description",
  accessorKey: "description",
  sortingFn: "alphanumeric",
  cell: ({ getValue }) => (
    <LineClampedTooltip>{getValue() as string}</LineClampedTooltip>
  ),
});

export const StartDateCol = (): ColType => ({
  header: "Start Date",
  accessorKey: "start_date",
  sortingFn: "alphanumeric",
  cell: ({ row }) => {
    const isoDateStr = row.original.start_date;
    return formatDate(isoDateStr);
  },
});

export const EndDateCol = (): ColType => ({
  header: "End Date",
  accessorKey: "end_date",
  sortingFn: "alphanumeric",
  cell: ({ row }) => {
    const isoDateStr = row.original.end_date;
    return isoDateStr ? formatDate(isoDateStr) : "No end date";
  },
});

export const StatusCol = (): ColType => ({
  header: "Status",
  accessorKey: "status", // Virtual column, not present in data
  sortingFn: (rowA, rowB) => {
    const statusA = calcReferralSourceStatus(rowA.original);
    const statusB = calcReferralSourceStatus(rowB.original);
    const orderedStatuses = [
      REFERRAL_SOURCE_STATUSES.ended,
      REFERRAL_SOURCE_STATUSES.active,
      REFERRAL_SOURCE_STATUSES.notStarted,
    ];

    return orderedStatuses.indexOf(statusA) - orderedStatuses.indexOf(statusB);
  },
  cell: ({ row }) => {
    const status = calcReferralSourceStatus(row.original);
    return <ReferralSourceStatusBadge status={status} />;
  },
});

export const allCols = [
  NameCol(),
  DescriptionCol(),
  StartDateCol(),
  EndDateCol(),
  StatusCol(),
];
